(function () {
  // Utility: measure width even if off flow
  const measureWidth = (el) => el.getBoundingClientRect().width;

  function buildMarquee(root) {
    const viewport = root.querySelector(".marquee__viewport");
    const track = root.querySelector(".marquee__track");
    const seed = root.querySelector(".marquee__content");
    if (!viewport || !track || !seed) return;

    // Read config
    const gap =
      parseFloat(
        root.dataset.gap || getComputedStyle(root).getPropertyValue("--gap")
      ) || 20;
    const speed =
      parseFloat(
        root.dataset.speed || getComputedStyle(root).getPropertyValue("--speed")
      ) || 80;
    const direction =
      (root.dataset.direction || "ltr").toLowerCase() === "rtl" ? -1 : 1;

    // Reset track to only the seed
    track.innerHTML = "";
    seed.style.margin = "0"; // guard
    track.appendChild(seed);

    // Apply CSS vars
    root.style.setProperty("--gap", gap + "px");
    root.style.setProperty("--dir", String(direction));

    // Clone until we exceed 2× viewport width (for seamless loop)
    const vw = measureWidth(viewport);
    let acc = measureWidth(seed);
    // Create a fragment for performance
    const frag = document.createDocumentFragment();

    // Minimum 2 copies for wrap; fill to >= 2× viewport
    while (acc < vw * 2) {
      const clone = seed.cloneNode(true);
      frag.appendChild(clone);
      acc += measureWidth(clone) + gap;
    }
    track.appendChild(frag);

    // Now compute total track width of ALL children
    const totalChildren = Array.from(track.children);
    const totalW = totalChildren.reduce((sum, node, idx) => {
      const w = measureWidth(node);
      // Add gap between items; track uses flex gap, but we emulate total
      return sum + w + (idx ? gap : 0);
    }, 0);

    // We translate by half of the *repeating pattern* so the second half
    // aligns perfectly with the first, creating a seamless loop.
    // Because we filled >= 2× viewport, half the sequence covers the screen.
    root.style.setProperty("--track-w", totalW + "px");

    // Duration = distance / speed, where distance = half of total (px)
    const durationSec = totalW / 2 / speed;
    root.style.setProperty("--duration", durationSec + "s");

    // Accessibility: pause on focus within
    track.addEventListener(
      "focusin",
      () => (track.style.animationPlayState = "paused")
    );
    track.addEventListener(
      "focusout",
      () => (track.style.animationPlayState = "")
    );

    // Rebuild on resize (debounced)
    let t;
    const rebuild = () => {
      clearTimeout(t);
      t = setTimeout(() => buildMarquee(root), 120);
    };
    const ro = new ResizeObserver(rebuild);
    ro.observe(viewport);
  }

  // Init all marquees
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-marquee]").forEach(buildMarquee);
  });
})();
